// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"da6aad40","283":"ec67c3d6","453":"0bf32aea","709":"8edd31a9","713":"a2dbc78b"}[chunkId] + ".chunk.js";
};